import React from 'react'
import { createStyles, makeStyles, ActionButton, TableCell, TableRow } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export interface MobilePersonRowAction {
  key: string
  label: string
  icon: React.ComponentType<any>
}

interface MobilePersonRowProps {
  name: string
  addressLine?: string
  phoneLine?: string
  actions: MobilePersonRowAction[]
  actionsDisabled?: boolean
  'data-testid'?: string
  className?: string
  onClick: (ev: React.MouseEvent<any>) => void
  onActionClick: (action: string) => void
}

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    mobileRow: {
      padding: theme.spacing(1, 2),
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer'
    },
    mobileContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    mobileText: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0
    },
    mobileName: {
      fontWeight: theme.typography.fontWeightMedium
    },
    mobileSubtext: {
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(0.5)
    }
  })
)

export default function MobilePersonRow({
  name,
  addressLine,
  phoneLine,
  actions,
  actionsDisabled,
  'data-testid': testId,
  className,
  onClick,
  onActionClick
}: MobilePersonRowProps) {
  const classes = useStyles()

  return (
    <TableRow data-testid={testId} className={className} onClick={onClick}>
      <TableCell colSpan={99} style={{ padding: 0 }}>
        <div className={classes.mobileRow}>
          <div className={classes.mobileContent}>
            <div className={classes.mobileText}>
              <span className={classes.mobileName}>{name}</span>
              {(addressLine || phoneLine) && (
                <span className={classes.mobileSubtext}>
                  {addressLine && <span>{addressLine}</span>}
                  {addressLine && phoneLine && <br />}
                  {phoneLine && <span>{phoneLine}</span>}
                </span>
              )}
            </div>
            {actions.length > 0 && (
              <ActionButton
                data-testid="actions"
                actions={actions}
                disabled={actionsDisabled}
                onActionClick={(ev, action) => {
                  ev.stopPropagation()
                  onActionClick(action)
                }}
              />
            )}
          </div>
        </div>
      </TableCell>
    </TableRow>
  )
}
